import { Component, Input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { IPitch } from '../../../shared/model/pitch.interface';
import { ISlot } from './slot.component.interface';

import { fadeInFadeOutAnimation } from '../../../shared/animations/fadeIn.fadeOut.animation';
import { SlotService } from './slot.service';

@Component({
    selector: 'mlp-ng-slot',
    templateUrl: './slot.component.html',
    styleUrls: ['./slot.component.scss'],
    animations: [fadeInFadeOutAnimation]
})

export class SlotSharedComponent {
    @Input() slot: ISlot;
    @Input() pitch: IPitch;
    showMenu = false;
    flippingDelay;

    constructor(public slotService: SlotService,  private cp: CurrencyPipe) {
    }

    toggleMenu(state: string): void {
        const slot = this.slot;
        if (state === 'enter' && slot && slot.attributes) {
            this.flippingDelay = setTimeout(() => {
            this.showMenu = true;
            }, 400);
        }
        if (state === 'leave') {
            this.showMenu = false;
            clearTimeout(this.flippingDelay);
        }
    }

    getTextForSlot(slot: ISlot, pitch: IPitch): string {
        if (this.slotService.isUnavailableSlot(slot)) {
            return 'unavailable';
        } else if (this.slotService.isConfirmedBooking(slot, pitch) || this.slotService.isCascadingBooking(slot, pitch)) {
            return 'booked';
        }

        const booking = this.slotService.getBookingFromSlot(slot, pitch);

        if (booking && slot.attributes.availabilities === 0 && pitch.id != booking.relationships.pitch.data.id && booking.attributes.status === 'cancelled') {
            return 'cancelled';
        } else if (booking && booking.attributes.status === 'pending') {
            return 'pending';
        }

        return this.cp.transform(slot.attributes.price, slot.attributes.currency);
    }
}
